import React from "react";
import IMG1 from "../assets/img/fib1.png";
import IMG2 from "../assets/img/Word2.jfif";
import IMG3 from '../assets/img/rimage.jpg'
import { Link } from "react-router-dom";
function SpellGames() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        marginTop: "90px",
      }}
    >
      <Link to="/learn-words">
        <img
          src={IMG2}
          style={{ height: "300px", width: "300px", borderRadius: "5px" }}
        />
      </Link>
      <Link to="/games/spelling-game">
        <img
          src={IMG1}
          style={{ height: "300px", width: "300px", borderRadius: "5px" }}
        />
        
      </Link>
      <Link to="/rotate-puzzle">
        <img
          src={IMG3}
          style={{ height: "300px", width: "300px", borderRadius: "5px" }}
        />
        </Link>
    </div>
  );
}

export default SpellGames;
